import "./ShowcaseContainer.css";

export const ShowcaseContainer = ({ children }) => {
  return (
      <div className="section-container">{children}</div>
  );
};